<style scoped>
.footerBox {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 7.5rem;
  height: 1rem;
  background: #fff;
  /*border-top: .01rem solid #E9E9E9;*/
  box-sizing: border-box;
  z-index: 999;
}
.footerItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  font-size: 0.24rem;
  color: #808080;
  height: 0.8rem;
}

.footerItem.active {
  color: #408bfb;
}

.footerItem.active .f1 {
  background: url("~assets/fa1.png") no-repeat center/cover;
}

.footerItem.active .f2 {
  background: url("~assets/fa2.png") no-repeat center/cover;
}

.footerItem.active .f3 {
  background: url("~assets/fa3.png") no-repeat center/cover;
  width: 0.36rem;
  height: 0.44rem;
}

.footerItem.active .f4 {
  background: url("~assets/fa4.png") no-repeat center/cover;
}

.footerItemIcon {
  width: 0.4rem;
  height: 0.4rem;
  /*margin-bottom: .1rem;*/
}
.f1 {
  background: url("~assets/f1.png") no-repeat center/cover;
  width: 0.39rem;
  height: 0.43rem;
}
.f2 {
  background: url("~assets/f2.png") no-repeat center/cover;
  width: 0.42rem;
  height: 0.41rem;
}
.f3 {
  background: url("~assets/f3.png") no-repeat center/cover;
  width: 0.36rem;
  height: 0.44rem;
}
.f4 {
  background: url("~assets/f4.png") no-repeat center/cover;
  width: 0.44rem;
  height: 0.44rem;
}
</style>

<template>
  <div>
    <div>备案号：<a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2022022616号</a></div>
    <div class="footerBox">
      <div class="footerItem" :class="{ active: active === '1' }" @click="to('')">
        <div class="footerItemIcon f1"></div>
        首页
      </div>
      <div
        class="footerItem"
        :class="{ active: active === '2' }"
        @click="to('ask')"
      >
        <div class="footerItemIcon f2"></div>
        咨询
      </div>
      <div
        class="footerItem"
        :class="{ active: active === '3' }"
        @click="to('test')"
      >
        <div class="footerItemIcon f3"></div>
        测评
      </div>
      <div
        class="footerItem"
        :class="{ active: active === '4' }"
        @click="to('my')"
      >
        <div class="footerItemIcon f4"></div>
        我的
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["active"],
  methods: {
    to(n) {
      this.$router.push(`/${n}`);
    },
    back() {
      var ua = navigator.userAgent;
      if (this.$route.query.type == 1) {
        var isIos = /iPhone/i.test(ua);
        var isAndroid = /Android/i.test(ua);
        isIos && window.webkit.messageHandlers.BackToNormal.postMessage(1);
        isAndroid && XinMaoEap.finshActivity();
      } else {
        history.back();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/footer.vue?4a0cfb9e